module.exports = __webpack_public_path__ + "4f4f3403dc995ce7a6a94a7fcf9061cc.svg";